import { InjectionToken, Provider } from '@angular/core';
import type { FirebaseApp } from 'firebase/app';
import type { Auth } from 'firebase/auth';
import type { Firestore } from 'firebase/firestore';
import type { FirebaseStorage } from 'firebase/storage';
import type { Functions } from 'firebase/functions';

export const FIREBASE_APP = new InjectionToken<FirebaseApp>('firebase.app');
export const FIREBASE_AUTH = new InjectionToken<Auth>('firebase.auth');
export const FIREBASE_FIRESTORE = new InjectionToken<Firestore>('firebase.firestore');
export const FIREBASE_STORAGE = new InjectionToken<FirebaseStorage>('firebase.storage');
export const FIREBASE_FUNCTIONS = new InjectionToken<Functions>('firebase.functions');

export interface FirebaseProviderConfig {
  app: () => FirebaseApp;
  auth?: () => Auth;
  firestore?: () => Firestore;
  storage?: () => FirebaseStorage;
  functions?: () => Functions;
}

export function provideFirebase(config: FirebaseProviderConfig): Provider[] {
  const providers: Provider[] = [
    { provide: FIREBASE_APP, useFactory: config.app },
  ];
  if (config.auth) providers.push({ provide: FIREBASE_AUTH, useFactory: config.auth });
  if (config.firestore) providers.push({ provide: FIREBASE_FIRESTORE, useFactory: config.firestore });
  if (config.storage) providers.push({ provide: FIREBASE_STORAGE, useFactory: config.storage });
  if (config.functions) providers.push({ provide: FIREBASE_FUNCTIONS, useFactory: config.functions });
  return providers;
}
